import { render, staticRenderFns } from "./LawyerViewPage.vue?vue&type=template&id=4f56ed68&scoped=true"
import script from "./LawyerViewPage.vue?vue&type=script&lang=js"
export * from "./LawyerViewPage.vue?vue&type=script&lang=js"
import style0 from "./LawyerViewPage.vue?vue&type=style&index=0&id=4f56ed68&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f56ed68",
  null
  
)

export default component.exports